export function notUndefined(value: any): boolean {
    return value !== undefined;
}

export function pick<T extends object, K extends keyof T>(
    object: T,
    ...keys: K[]
): Pick<T, K> {
    const ret: any = {};
    keys.forEach((key) => {
        ret[key] = object[key];
    });
    return ret;
}

export function isNotEmptyObject(value: object): boolean {
    return Object.keys(value).length > 0;
}

export function hasNonNullProperty(object: object): boolean {
    return Object.values(object).some((value) => value !== null && value !== undefined);
}

export function concatenateValues(obj: Record<string, string[]>): string[] {
    return Object.values(obj).flat();
}
